module.exports = __webpack_public_path__ + "img/BannerProHome2.a4e2bb66.webp";